// src/router/protectedRoutes.js
export const protectedRoutes = ['/visit','/balance','/workinghours'];
